import type { CheckIssue } from '../types/taxonomy-studio.types';

/**
 * Where a check's target lives: nodes and attachments open the node in Product
 * Taxonomy (`neckline@2271` → node 2271); attributes, values, scopes and GMC rows open
 * the attribute sheet (`neckline/boat_neck` → `neckline`).
 */
export function issueDestination(
  target: CheckIssue['target'],
): { kind: 'node'; id: number } | { kind: 'section'; key: string } | null {
  if (!target) return null;
  if (target.type === 'NODE') {
    const id = Number(target.key);
    return Number.isFinite(id) ? { kind: 'node', id } : null;
  }
  if (target.type === 'ATTACHMENT') {
    const id = Number(target.key.split('@')[1]);
    return Number.isFinite(id) ? { kind: 'node', id } : null;
  }
  const key = target.key.split('/')[0]?.split('@')[0];
  return key ? { kind: 'section', key } : null;
}
